module.exports = __webpack_public_path__ + "img/noChanges.42e2cbe7.svg";